import React, { ButtonHTMLAttributes } from 'react';
import styles from './button.module.css';

type ButtonVariant = 'primary' | 'secondary' | 'tertiary';

type ButtonType = ButtonHTMLAttributes<HTMLButtonElement> & {
  title: string
  Icon?: React.ComponentType<{ className?: string }>;
  containerClass?: string;
  onClick: () => void;
  variant: ButtonVariant
};

const VARIANT_STYLES: Record<ButtonVariant, { container: string; title: string }> = {
  primary: {
    container: styles.primary,
    title: styles.btnText,
  },
  secondary: {
    container: styles.secondary,
    title: `${styles.btnText} ${styles.secondaryTitle}`,
  },
  tertiary: {
    container: styles.tertiary,
    title: `${styles.btnText} ${styles.tertiaryTitle}`,
  },
};

const Button = ({Icon, title, containerClass, onClick, variant = 'primary'}: ButtonType) => {
    const { container, title: titleClass } = VARIANT_STYLES[variant];

  return (
    <button
      className={[styles.button, container, containerClass].filter(Boolean).join(' ')}
      onClick={onClick}
    >
      {Icon && <Icon className={styles.symbol}/>}
      <p className={titleClass}>{title}</p>
    </button>
  );
};

export default Button;
